interface JobCatalogNode {
  id: number
  node_uuid: string
  type:
    | 'jobcatalog_treeroot'
    | 'jobcatalog_treefamily'
    | 'jobcatalog_treefunction'
    | 'jobcatalog_treerole'
    | 'jobcatalog_treelevel'
  ancestor_id: number | null
  name: string
  description: string | null
  children: JobCatalogNode[]
}

interface JobCatalogResult {
  roleName: string | null
  levelName: string | null
}

export const getJobCatalogRoleAndLevel = (
  serializedTree: string,
  jobCatalogLevelUuid: string,
  jobCatalogRoleUuid: string
): JobCatalogResult => {
  if (!serializedTree || serializedTree.trim() === '') {
    return {
      roleName: '',
      levelName: '',
    }
  }

  try {
    const tree: JobCatalogNode = JSON.parse(serializedTree)

    const findNodeByUuid = (node: JobCatalogNode, uuid: string): JobCatalogNode | null => {
      if (node.node_uuid === uuid) {
        return node
      }

      for (const child of node.children) {
        const found = findNodeByUuid(child, uuid)
        if (found) {
          return found
        }
      }

      return null
    }

    const roleNode = findNodeByUuid(tree, jobCatalogRoleUuid)
    const levelNode = findNodeByUuid(tree, jobCatalogLevelUuid)

    return {
      roleName: roleNode?.name || null,
      levelName: levelNode?.name || null,
    }
  } catch (error) {
    return {
      roleName: null,
      levelName: null,
    }
  }
}
